<script setup lang="ts">
import { QSpinnerTail } from 'quasar';

import type { LocalizableString } from '@/services/types/api.types';

// PROPS
const props = defineProps<{
  loadingText: LocalizableString | string;
  showSpinner: boolean;
}>();
</script>
<template>
  <div class="base-loading" v-if="props.showSpinner">
    <q-spinner-tail color="primary" size="4em" />
    <div class="base-loading__text">{{ props.loadingText }}</div>
  </div>
</template>
<style lang="scss">
.base-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
